// extracted by mini-css-extract-plugin
export var stars = "stars-module--stars--Q3HY2";
export var animStar = "stars-module--animStar--1yPmI";
export var stars2 = "stars-module--stars2--1UIFn";
export var stars3 = "stars-module--stars3--1faCM";